import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonConfig, ButtonModule, ImgGeneratorModule } from '@collab/comp-library';
import { FilesUploadedTableI } from '../file-upload/model/filesUploadedTable';
import { FormInlineErrorComponent } from '../form-inline-error/form-inline-error.component';
import { FILE_UPLOAD_ERRORS } from '../../constants/form-error.constants';

@Component({
  selector: 'app-file-input',
  standalone: false,
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss']
})
export class FileInputComponent implements OnInit {

  // @Input() public acceptedFileType = "";
  // @Input() public maxFileSize!: number;
  @Output() public fileUploaded = new EventEmitter<File | null>();
  @Input() public acceptedFileType: string = ".png,.svg,.img";
  @Input() public maxFileSize: number = 2 * 1024 * 1024; // 2MB in bytes;
  @Input() public existingImagePath: string | null = null;


  public errorType: string[] = [];
  public isFileType = false;
  public fileErrors = FILE_UPLOAD_ERRORS;
  public filesUploadedData: FilesUploadedTableI[] = [];
  public uploadedFiles: any;

  public browseButtonConfig: ButtonConfig = {
    text: 'Upload File',
    buttonSize: 'small',
    buttonType: 'secondary',
    iconURL: '',
    imageUrl: '',
    linkURL: ''
  };

  //   public uploadFile(event: Event): void {
  //     this.errorType = [];

  //     const inputElement = event.target as HTMLInputElement;
  //     if (!inputElement.files || inputElement.files.length === 0) {
  //         return;
  //     }

  //     const file = inputElement.files[0];
  //     if (this.maxFileSize && file.size > this.maxFileSize) {
  //         this.isFileType = true;
  //         const maxFileSizeInMB = (this.maxFileSize / (1024 * 1024)).toFixed(2);
  //         this.errorType.push(`${this.fileErrors.attachFile.maxFileSize} ${maxFileSizeInMB}MB`);
  //         this.fileUploaded.emit(null);
  //         return;
  //     }
  //     const fileExtn = '.' + file.name.split('.').pop()?.toLowerCase();
  //     const allowedExtensions = ['.svg', '.img', '.png'];
  //     if (!allowedExtensions.includes(fileExtn)) {
  //         this.isFileType = true;
  //         this.errorType.push(this.fileErrors.attachFile.fileType);
  //         this.fileUploaded.emit(null);
  //         return;
  //     }
  //     this.filesUploadedData = [{ documentName: file.name, documentSize: file.size }];
  //     this.uploadedFiles = file;
  //     this.fileUploaded.emit(this.uploadedFiles);
  //     this.isFileType = false;
  // }

  ngOnInit(): void {
    if (this.existingImagePath) {
      this.displayExistingImage(this.existingImagePath);
    }
  }


  public displayExistingImage(imagePath:any) {
    if (!imagePath) {
      return;
    }
    let fileName = 'existing-image';
    try {
      fileName = imagePath.split('/').pop() || fileName;
    } catch (error) {
      console.warn('Error extracting filename from path:', error);
    }

    const fileSize = 0;

    this.filesUploadedData = [{ documentName: fileName, documentSize: fileSize }];
  }

  public uploadFile(event: Event): void {
    this.errorType = [];

    const inputElement = event.target as HTMLInputElement;
    if (!inputElement.files || inputElement.files.length === 0) {
      return;
    }

    const file = inputElement.files[0];
    if (file.size > this.maxFileSize) {
      this.isFileType = true;
      this.errorType.push(`File size should not exceed 2MB`);
      this.fileUploaded.emit(null);
      return;
    }

    const fileExtn = '.' + file.name.split('.').pop()?.toLowerCase();
    const allowedExtensions = ['.svg', '.img', '.png'];
    if (!allowedExtensions.includes(fileExtn)) {
      this.isFileType = true;
      this.errorType.push(this.fileErrors.attachFile.fileType);
      this.fileUploaded.emit(null);
      return;
    }

    this.isFileType = false;
    this.filesUploadedData = [{ documentName: file.name, documentSize: file.size }];
    this.uploadedFiles = file;
    this.existingImagePath = null;
    this.fileUploaded.emit(this.uploadedFiles);
  }


  public deleteAttachment(): void {
    this.filesUploadedData = [];
    this.uploadedFiles = null;
    this.existingImagePath = null;
    this.isFileType = false;
    this.errorType = [];
    this.fileUploaded.emit(null);
  }

}
